import { Fragment } from 'react'
import { List, ListItemButton, ListItemText, ListSubheader, Badge } from '@mui/material'

interface ContainerListProps {
  containers: Record<string, number>
  selectedKey: string | null
  onSelect: (key: string) => void
}

const ContainerList = ({ containers, selectedKey, onSelect }: ContainerListProps) => {
  const groups = Object.entries(containers)
    .sort(([a], [b]) => a.localeCompare(b))
    .reduce<Record<string, { key: string; container: string; count: number }[]>>((acc, [key, count]) => {
      const [db, container] = key.split('/')
      ;(acc[db] ??= []).push({ key, container, count })
      return acc
    }, {})

  return (
    <List dense sx={{ overflow: 'auto' }} subheader={<li />}>
      {Object.entries(groups).map(([db, items]) => (
        <Fragment key={db}>
          <ListSubheader disableSticky>{db}</ListSubheader>
          {items.map(({ key, container, count }) => (
            <ListItemButton
              key={key}
              selected={selectedKey === key}
              onClick={() => onSelect(key)}
              sx={{ pl: 3 }}
            >
              <ListItemText primary={container} />
              <Badge badgeContent={count} color="primary" sx={{ ml: 1 }} />
            </ListItemButton>
          ))}
        </Fragment>
      ))}
    </List>
  )
}

export default ContainerList
